import { NodeIds } from '@breathelife/insurance-form-builder';
import { LineOfBusinessName } from '@breathelife/types';
import { QuestionnaireEngine, RenderingSectionGroup, isRenderingRepeatedSectionGroup } from '@zinnia/form-engine-sdk';
import { PlatformFeatures } from '../Models/PlatformFeatures';

export function getApplicantFullName(
  questionnaireEngine: QuestionnaireEngine,
  lineOfBusiness: LineOfBusinessName,
  features: PlatformFeatures,
): string {
  const firstName = questionnaireEngine.getAnswer(
    features.assistedApplication?.nodeIdsApplicantFullNamePerLineOfBusiness?.[lineOfBusiness]?.firstName,
    {},
  );
  const lastName = questionnaireEngine.getAnswer(
    features.assistedApplication?.nodeIdsApplicantFullNamePerLineOfBusiness?.[lineOfBusiness]?.lastName,
    {},
  );

  return [firstName, lastName].filter(Boolean).join(' ');
}

export function getInsuredDateOfBirth(questionnaireEngine: QuestionnaireEngine): string {
  return (questionnaireEngine.getAnswer(NodeIds.insuredDateOfBirth, {}) as string) || '';
}

export enum SectionGroupId {
  insuredPeople = 'insuredPeople',
  contract = 'contract',
  medicalQuestionnaire = 'medicalQuestionnaire',
}

function getSectionGroupId(sectionGroup: RenderingSectionGroup): string {
  if (isRenderingRepeatedSectionGroup(sectionGroup)) {
    return sectionGroup.scope.parentId;
  } else {
    return sectionGroup.id;
  }
}

export function isInsuredPeopleSectionGroup(sectionGroup: RenderingSectionGroup): boolean {
  const sectionGroupId = getSectionGroupId(sectionGroup);

  return sectionGroupId === SectionGroupId.insuredPeople;
}

export function convertYesNoToBoolean(value: unknown): boolean | undefined {
  switch (value) {
    case 'yes':
      return true;
    case 'no':
      return false;
    default:
      return undefined;
  }
}
